<template>
  <child-container
      :container-name="containerName"
      :container-title="title"
      overflow-val="visible"
      ref="container"
      v-on:container-hidden="containerHidden"
      v-on:container-shown="containerShown"
  >
    <multiple-forms-component
        :form-rows="formRows"
        :initial-form-data="initialFormData"
        :buttons="buttons"
        :form-width="formWidth"
        :viewport-i-d="viewportID"
        :client-i-d="clientID"
        ref="form"
    >
    </multiple-forms-component>
  </child-container>
</template>

<script setup>
import { reactive, onMounted, watch, ref, nextTick, getCurrentInstance, onBeforeMount } from 'vue';
import ChildContainer from './../ChildContainer/ChildContainer.vue';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import MultipleFormsComponent from './../MultipleFormsComponent/MultipleFormsComponent.vue';

let props = defineProps({
  title: String,
  viewportID: String,
  clientID: String,
  defaultRole: String,
  addValuesToMessageBox: Boolean

});

let form = ref(null), formInstance = ref(null), containerName = `container${oxygenUtil.getUUID()}`, container = ref(null);



async function containerShown() {
  if(form.value.formInstance) {
    form.value.formInstance.destructor();
  }

  await nextTick();
  console.log('containerShown', 'form:', form.value);
  await form.value.initializeForm();
}





function containerHidden() {
  form.value.formInstance.destructor();
}
onMounted(()=>{

});

onBeforeMount(()=>{
  //initialFormProperties();
})

function show() {
  container.value.show();
}

function hide() {
  container.value.hide();
}

function showContainerAlignedToElement(...args) {
  container.value.showModalAlignedToElement(...args)
}

function showContainerAlignedToElementInViewport(...args) {
  container.value.showContainerAlignedToElementInViewport(...args)
}

/**
 * Form-related items
 */

let formRows = ref([]), buttons = ref([]), initialFormData = ref([]), formWidth = ref(400);
initialFormProperties();

function initialFormProperties() {
  formRows.value = [
    {
      type: "input",
      name: "token",
      label: "Enter Role Token",
      value: '',
      placeholder: 'Please enter a 6-digit code'
    }
  ];

  buttons.value = [
    { id: 'clear', html: 'Clear', callback: ()=>{
      }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
    { id: 'save', html: 'Save', callback: ()=>{
      console.log('save', 'elem:', document.getElementById(form.value.formInstance.getItem('token').config.id));
      }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
  ];

  initialFormData.value = [
    {
      token: "token-value"
    }
  ];
}

defineExpose({
  show,
  hide,
  showContainerAlignedToElement,
  showContainerAlignedToElementInViewport,
  formInstance
});
</script>

<style>
/*@import url('/simplia/dist/css/suite.min.css');*/
</style>